import { render } from "./CustomModal.vue?vue&type=template&id=196f1f84&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"

import "./CustomModal.vue?vue&type=style&index=0&id=196f1f84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196f1f84"]])

export default __exports__